const urlSearchParams = () => {
  const result = {};
  const searchParams = new URLSearchParams(decodeURI(window.location.search));
  searchParams.forEach((value, key) => {
    result[key] = value;
  });
  return result;
};
const objectAsURL = (data) => Object.keys(data).filter((key) => data[key]).map((key) => `${key}=${data[key]}`).join("&");
export {
  urlSearchParams as default,
  objectAsURL
};
//# sourceMappingURL=urlSearchParams.mjs.map
